export default "__VITE_ASSET__89TvM8Fm__"